import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import SpaceDetail from "@/pages/SpaceDetail";
import BookDesk from "@/pages/BookDesk";
import BookingSuccess from "@/pages/BookingSuccess";
import Vergaderzalen from "@/pages/Vergaderzalen";
import Events from "@/pages/Events";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vergaderzalen" element={<Vergaderzalen />} />
          <Route path="/events" element={<Events />} />
          <Route path="/spaces/:slug" element={<SpaceDetail />} />
          <Route path="/book-desk" element={<BookDesk />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
